import moment from "moment";
import { useEffect, useRef, useState } from "react";
import MyYuukke from "../../api/MyYuukke";
import { API_URL, BASE_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";

import { Rating } from "@material-ui/lab";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneNumberContainer from "../../components/PhoneNumberContainer";
import { themesPallates, neutralDefaultTheme, hexToRgba } from "../../components/Utils";

import "./bookingUiStyles.css";
import "./ServiceCardThemeV3.css";

import { MdOutlinePhoto, MdOutlineReviews, MdVerified } from "react-icons/md";
import { GrAnnounce } from "react-icons/gr";
import { BsCameraVideo } from "react-icons/bs";


import {
  FiCalendar,
  FiClock,
  FiCheck,
  FiMail,
  FiGlobe,
  FiShield,
  FiZap,
  FiShare2,
  FiArrowRight,
  FiChevronRight,
  FiVideo,
  FiExternalLink,
  FiRefreshCw,
  FiFileText,
  FiDownload,
  FiLock,
  FiX,
} from "react-icons/fi";
import { FaStar, FaWhatsapp } from "react-icons/fa";

moment.locale("en");

function MonthGridCalendar({
  slots,
  packageDays,
  selectedValue,
  hoverCol,
  onSelect,
}) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));
  const [animKey, setAnimKey] = useState(0);

  const availableSet = new Set(
    (slots || []).filter((s) => s.available).map((s) => s.value),
  );
  const slotMap = {};
  (slots || []).forEach((s) => {
    slotMap[s.value] = s;
  });

  const goMonth = (dir) => {
    setViewMonth((prev) =>
      prev.clone().locale("en").add(dir, "month").startOf("month"),
    );
    setAnimKey((k) => k + 1);
  };

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth
    .clone()
    .locale("en")
    .isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow">
        <button
          className="monthNavBtn"
          onClick={() => goMonth(-1)}
          disabled={isPrevDisabled}
        >
          ‹
        </button>
        <h4>{vmEn.format("MMMM YYYY")}</h4>
        <button className="monthNavBtn" onClick={() => goMonth(1)}>
          ›
        </button>
      </div>
      <table className="monthGridCalendar" key={animKey}>
        <thead>
          <tr>
            {DOW.map((d) => (
              <th key={d}>{d}</th>
            ))}
          </tr>
        </thead>
        <tbody className="monthGridAnim">
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day)
                  return (
                    <td key={di}>
                      <button className="gridDayBtn emptyDay">0</button>
                    </td>
                  );
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const isToday = vmEn.clone().date(day).isSame(today, "day");
                const dayMatches =
                  packageDays.length === 0 ||
                  packageDays.includes(
                    moment(dateVal, "YYYY/MM/DD")
                      .locale("en")
                      .format("ddd")
                      .toUpperCase(),
                  );
                const isAvail =
                  availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;
                const btnClass = [
                  "gridDayBtn",
                  isSelected ? "gridSelected" : "",
                  isToday && !isSelected ? "gridToday" : "",
                  isAvail && !isSelected ? "gridAvailable" : "",
                  !isAvail && !isSelected ? "gridDisabled" : "",
                ]
                  .filter(Boolean)
                  .join(" ");
                return (
                  <td key={di}>
                    <button
                      className={btnClass}
                      onClick={() => {
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function TimeSidePanel({
  hasDateSelected,
  slots,
  selectedSlot,
  hoverCol,
  onSelect,
  isDisabledFn,
}) {
  return (
    <div className="timeSide">
      <div className="panelLabel">
        <FiClock size={13} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div className="calEmptyState">
          <FiCalendar size={40} color="#c4c9d8" />
          <p>
            <strong>No date selected</strong>
            Pick a date on the left to see available time slots
          </p>
        </div>
      ) : (
        <div className="timeSlotGrid slotPanel">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt =
                fromStr.includes("AM") || fromStr.includes("PM")
                  ? "hh:mm A"
                  : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid()
                ? moment(fromStr, fmt).format("h:mm A")
                : fromStr;
              const displayTo = moment(toStr, fmt).isValid()
                ? moment(toStr, fmt).format("h:mm A")
                : toStr;
              const isSelected =
                selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;
              return (
                <button
                  key={i}
                  className={`timeSlotBtn${isSelected ? " tsActive" : ""}${isDisabled ? " tsDisabled" : ""}`}
                  style={isSelected ? { background: hoverCol } : {}}
                  onClick={() => {
                    if (!isDisabled) onSelect(item);
                  }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p className="noTimeMsg">No slots available for this date</p>
          )}
        </div>
      )}
    </div>
  );
}

const ServiceCardThemeV3 = ({
  data,
  selectService,
  userUpcomingMeting,
  isPreview,
  onSendMsgClick,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  handleOpenReviews,
  onResourceClick,
}) => {
  const businessLogo = isPreview
    ? data.eventDetails?.businessLogo
    : data.eventDetails?.businessLogo
      ? `${API_URL}auth/image/${data.eventDetails?.businessLogo}`
      : calendar;

  const [state, setState] = useState({
    serviceGalleryImage: [],
    serviceProviderVideo: [],
    serviceAnnouncement: [],
  });

  const [chosenRes, setChosenRes] = useState({ type: "", url: "" });
  const [showResModal, setShowResModal] = useState(false);
  const isMobile = window.screen.width < 768;

  const [chosenService, setChosenService] = useState(null);
  const [focusTab, setFocusTab] = useState(0);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const scheduleRef = useRef(null);
  const servicesSectionRef = useRef(null);

  const hoverCol =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--brand")
      ?.trim() || "#161616";

  const resTabList = [
    {
      title: "Announcements",
      id: 0,
      key: "serviceAnnouncement",
      icon: <GrAnnounce />,
    },
    {
      title: "Photos",
      id: 1,
      key: "serviceGalleryImage",
      icon: <MdOutlinePhoto />,
    },
    {
      title: "Videos",
      id: 2,
      key: "serviceProviderVideo",
      icon: <BsCameraVideo />,
    },
    { title: "Reviews", id: 3, key: "reviewList", icon: <MdOutlineReviews /> },
  ];

  const [videoPlaying, setVideoPlaying] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);

  const scrollToRef = (ref) =>
    ref?.current?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    if (data?.userDetails?.userName || data?.eventDetails?.businessName)
      setMeta(
        "yuukkeServicedescription",
        `Profile of ${data?.userDetails?.userName || data?.eventDetails?.businessName}, offering amazing services.`,
      );
    if (data?.eventDetails?.slug)
      setMeta(
        "yuukkeServiceUrl",
        `${BASE_URL}yuukke-service/${data?.eventDetails?.slug}`,
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Full dynamic theming, unified with ServiceCardThemeV2. Both card
  // components now write the exact same shared CSS variable names
  // (--primary, --background, --card, --card-foreground, --border,
  // --desText, --tagtxtCol, --firstTagBg/--secTagBg/--ThirdTagBg, etc.)
  // and fall back to the same neutralDefaultTheme object from Utils.js
  // when no custom theme is set. This file's own --v3-* / --brand /
  // --brand-soft tokens (used throughout ServiceCardThemeV3.css) are
  // now just CSS aliases onto these shared variables, so whichever of
  // the two components is mounted, the palette can't disagree.
  useEffect(() => {
    const rootStyle = document.documentElement.style;
    const customThemeItem = data.eventDetails?.customTheme
      ? themesPallates.find((item) => item.id === data.eventDetails.themeId)
      : null;
    const theme = customThemeItem || neutralDefaultTheme;

    rootStyle.setProperty("--primary", theme.primary);
    rootStyle.setProperty("--primaryColor", theme.primary);
    rootStyle.setProperty("--primaryHover", theme.primaryHover);
    rootStyle.setProperty("--accent", theme.accent);
    rootStyle.setProperty("--background", theme.background);
    rootStyle.setProperty("--card", theme.card);
    rootStyle.setProperty("--card-foreground", theme.cardForeground);
    rootStyle.setProperty("--cardHover", theme.cardHover);
    rootStyle.setProperty("--border", theme.border);
    rootStyle.setProperty("--thinBorder", theme.thinBorder);
    rootStyle.setProperty("--thinBg", theme.thinBg);
    rootStyle.setProperty("--indiDot", theme.indiDot);
    rootStyle.setProperty("--headingColor", theme.heading);
    rootStyle.setProperty("--subHeadingColor", theme.subHeading);
    rootStyle.setProperty("--secondaryColor", theme.secondary);
    rootStyle.setProperty("--desText", theme.desText);
    rootStyle.setProperty("--tagtxtCol", theme.tagtxtCol);
    rootStyle.setProperty("--firstTagBg", theme.firstTagBg);
    rootStyle.setProperty("--secTagBg", theme.secTagBg);
    rootStyle.setProperty("--ThirdTagBg", theme.thirdTagBg);
    rootStyle.setProperty("--gradeStart", theme.lightGradeStart);
    rootStyle.setProperty("--gradeEnd", theme.lightGradeEnd);
    rootStyle.setProperty(
      "--shadow",
      `0 10px 30px -12px ${hexToRgba(theme.primary, 0.24)}`,
    );
  }, [data]);

  useEffect(() => {
    if (chosenService !== null)
      setTimeout(
        () => scheduleRef.current?.scrollIntoView({ behavior: "smooth" }),
        0,
      );
  }, [chosenService]);

  useEffect(() => {
    if (isPreview) {
      const arr = new Array(5).fill(10).map((_, i) => {
        const dt = moment(new Date()).locale("en").add("day", i);
        return {
          day: dt.format("ddd"),
          date: dt.format("MMM DD"),
          available: true,
          value: dt.format("YYYY/MM/DD"),
        };
      });
      data.slots = arr;
      setState((prev) => ({
        ...prev,
        serviceProviderVideo: data.serviceProviderVideo,
        serviceAnnouncement: data.serviceAnnouncement,
        serviceGalleryImage: data.serviceGalleryImage,
      }));
    } else {
      let serviceProviderVideo = [],
        serviceAnnouncement = [],
        serviceGalleryImage = [];
      if (data.eventDetails.serviceProviderVideo)
        serviceProviderVideo =
          data.eventDetails.serviceProviderVideo.split(",");
      if (data.eventDetails.serviceAnnouncement)
        serviceAnnouncement = data.eventDetails.serviceAnnouncement
          .split(",")
          .map((item) => `${API_URL}auth/image/${item}`);
      if (data.eventDetails.serviceGalleryImage)
        serviceGalleryImage = data.eventDetails.serviceGalleryImage
          .split(",")
          .map((item) => `${API_URL}auth/image/${item}`);
      setState((prev) => ({
        ...prev,
        serviceProviderVideo,
        serviceAnnouncement,
        serviceGalleryImage,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (!slugSelected || !data?.serviceList?.length) return;
    const index = data.serviceList.findIndex(
      (s) =>
        s.slug === slugSelected ||
        s.id === slugSelected ||
        String(s.id) === String(slugSelected),
    );
    if (index !== -1) {
      const item = data.serviceList[index];
      setChosenService(index);
      setIsPackageSelected(item);
      selectService(item);
      setTimeout(
        () => scheduleRef?.current?.scrollIntoView({ behavior: "smooth" }),
        200,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, data.serviceList]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) {
      return [];
    }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  // Closes the booking panel and clears everything tied to it — the
  // selected service, the date/time step, and the "Provide details" form
  // fields (name/email/phone/notes) plus the reCAPTCHA. Previously nothing
  // in this file reset the panel at all: chosenService only ever got set,
  // never cleared, and the detail-page form fields carried over between
  // services/sessions once entered.
  const closeBookingModal = () => {
    setChosenService(null);
    setIsPackageSelected({});
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("selectedSlot", null);
    updateState("detailsPage", false);
    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  const renderStepper = (activeStep) => (
    <div className="bkStepBar">
      <div
        className={`bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}
      >
        <div className="bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div
        className={`bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}
      >
        <div className="bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const activeProofList = state?.[resTabList[focusTab]?.key] || [];

  const serviceShareUrl = `${BASE_URL}yuukke-service/${data?.eventDetails?.slug || ""}`;
  const serviceShareQr = `${API_URL}auth/v2/qrcode/image?url=${encodeURIComponent(serviceShareUrl)}`;

  // ── Derived, single-source-of-truth values for the currently selected
  // service and the site-wide minimum price. Both the aside booking card
  // and the mobile sticky bar read from these so name/price never drift
  // or fall prey to `0 || fallback` treating a free (₹0) service as falsy.
  const selectedServiceObj =
    chosenService !== null ? data.serviceList?.[chosenService] : null;

  const validServiceAmounts = (data.serviceList || [])
    .map((s) => Number(s.amount))
    .filter((n) => !isNaN(n) && n >= 0);

  const minServiceAmount =
    validServiceAmounts.length > 0 ? Math.min(...validServiceAmounts) : null;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(serviceShareUrl);
      setCopiedLink(true);
      setTimeout(() => setCopiedLink(false), 2000);
    } catch (e) {
      window.prompt("Copy this link:", serviceShareUrl);
    }
  };

  const handleShare = async () => {
    const shareData = {
      title: data.eventDetails?.serviceName || "Check out this service",
      text: `Take a look at ${data.eventDetails?.serviceName || "this service"} on Yuukke`,
      url: serviceShareUrl,
    };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (e) {
        /* user cancelled */
      }
    } else {
      handleCopyLink();
    }
  };

  // ── WhatsApp share — sends the profile link (and, where the device
  // supports file sharing, the QR image too) directly to WhatsApp.
  // wa.me links can't carry an image, so the QR is only attached via the
  // native Web Share API (Files) on devices that support it; otherwise
  // this falls back to a text-only wa.me share which always works.
  const handleWhatsAppShare = async () => {
    const message = `Check out ${data.eventDetails?.serviceName || "this service"} on Yuukke: ${serviceShareUrl}`;

    try {
      if (navigator.canShare) {
        const response = await fetch(serviceShareQr);
        const blob = await response.blob();
        const qrFile = new File([blob], "service-qr.png", {
          type: blob.type || "image/png",
        });

        if (navigator.canShare({ files: [qrFile] })) {
          await navigator.share({
            title: data.eventDetails?.serviceName || "Check out this service",
            text: message,
            files: [qrFile],
          });
          return;
        }
      }
    } catch (e) {
      // fall through to text-only wa.me share below
    }

    const waUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(waUrl, "_blank", "noopener,noreferrer");
  };

  const reviews = data.reviewList ?? [];
  const avgRating = data.eventDetails?.ratings ?? null;
  const languages = (data.language || []).map((l) => l.language).join(" · ");

  const selectAndScroll = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
  };

  // ── Specialisations: DB value is a comma-separated string
  // (e.g. "Tailored business strategies,Expert advice sessions").
  // Render DB data when present; fall back to static sample tags when null/empty.
  const dbSpecialisations = data.eventDetails?.specialisations
    ? data.eventDetails.specialisations
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  const staticSpecialisations = [
    "1:1 sessions",
    "Flexible scheduling",
    "Video meetings",
    "Personalised guidance",
  ];

  const specialisationTags =
    dbSpecialisations.length > 0 ? dbSpecialisations : staticSpecialisations;

  // ── Success metrics: DB value is a JSON object string
  // (e.g. {"revenueGenerated":"$84M+","qualifiedLeads":"312k",...}).
  // Render DB data when present; fall back to static sample values when null/empty.
  const parseJsonSafe = (value, fallback) => {
    if (!value) return fallback;
    if (typeof value !== "string") return value;
    try {
      const parsed = JSON.parse(value);
      return parsed ?? fallback;
    } catch (e) {
      return fallback;
    }
  };

  const dbSuccessMetrics = parseJsonSafe(data.eventDetails?.successMetrics, {});
  const hasDbSuccessMetrics = Object.values(dbSuccessMetrics).some(
    (v) => v !== null && v !== undefined && String(v).trim() !== "",
  );

  const successMetricFieldMap = [
    { key: "revenueGenerated", icon: <FiZap size={18} />, label: "Revenue generated", staticValue: "$84M+" },
    { key: "qualifiedLeads", icon: <FiCheck size={18} />, label: "Qualified leads", staticValue: "312k" },
    { key: "avgConversionLift", icon: <FiRefreshCw size={18} />, label: "Avg. conversion lift", staticValue: "+284%" },
    { key: "avgRoas", icon: <FaStar size={18} />, label: "Avg. ROAS", staticValue: "5.8x" },
    { key: "avgCacReduction", icon: <FiChevronRight size={18} />, label: "Avg. CAC reduction", staticValue: "-62%" },
    { key: "organicSessionsPerYear", icon: <MdOutlineReviews size={18} />, label: "Organic sessions / yr", staticValue: "12.4M" },
    { key: "followersGrown", icon: <FiGlobe size={18} />, label: "Followers grown", staticValue: "+920k" },
    { key: "avgEmailOpenRate", icon: <FiMail size={18} />, label: "Avg. email open rate", staticValue: "48%" },
  ];

  const resourceList = data.resourceList || [];

const handleResourceCardClick = (res) => {
  if (isPreview) return;
  if (typeof onResourceClick === "function") onResourceClick(res);
};

  // When DB metrics exist, show only the ones actually filled in.
  // When no DB metrics exist at all, show the full static sample set.
  const successMetrics = hasDbSuccessMetrics
    ? successMetricFieldMap
        .filter((f) => String(dbSuccessMetrics[f.key] || "").trim() !== "")
        .map((f) => ({ icon: f.icon, value: dbSuccessMetrics[f.key], label: f.label }))
    : successMetricFieldMap.map((f) => ({ icon: f.icon, value: f.staticValue, label: f.label }));

  const bookingInner = (
    <>
      <div
        className="serviceBookingPanel"
        style={{
          display: chosenService !== null ? "flex" : "none",
          position: "relative",
        }}
      >
        {/* Close/reset control — clears the selected service and every
            field entered below (name/email/phone/notes) instead of
            leaving them to silently carry over into the next booking. */}
        {chosenService !== null && (
          <button
            type="button"
            className="v3-booking-close-btn"
            onClick={closeBookingModal}
            aria-label="Close booking panel"
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              zIndex: 5,
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              border: "1px solid var(--v3-border, #e2e8f0)",
              background: "#fff",
              color: "var(--v3-muted-fg, #64748b)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <FiX size={16} />
          </button>
        )}
        <div className="schedulePanel">
          <section className="serviceBookingSec">
            {data.detailsPage ? (
              <form
                onSubmit={uploadDetails}
                className="w-100 p-3 d-flex flex-column font-weight-bold slotBookingForm"
                style={{ fontSize: "12px", maxWidth: "95%" }}
              >
                {renderStepper(2)}
                <h5
                  className="font-weight-bold d-flex align-items-center"
                  style={{ marginTop: "1rem" }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      recaptcha?.current?.reset();
                      updateState("detailsPage", false);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      marginInlineEnd: 10,
                      fontSize: "1.5rem",
                      cursor: "pointer",
                    }}
                    aria-label="Back"
                  >
                    ←
                  </button>
                  Enter your details for further communication ..
                </h5>
                <label className="mt-2">Name *</label>
                <input
                  style={{ caretColor: "black" }}
                  className="input-text-input text-dark"
                  value={data.name}
                  type="text"
                  placeholder="Enter name"
                  required
                  onChange={(e) => updateState("name", e.target.value)}
                />
                <label className="mt-2">Email *</label>
                <input
                  style={{ caretColor: "black" }}
                  className="input-text-input text-dark"
                  value={data.email}
                  type="email"
                  placeholder="Enter email"
                  required
                  onChange={(e) => updateState("email", e.target.value?.trim())}
                />
                <label className="mt-2">Phone Number *</label>
                <PhoneNumberContainer
                  value={data.phoneNumber}
                  updateData={(e) => updateState("phoneNumber", e)}
                  defaultClass="custom-phone-input"
                />
                <label className="mt-2">
                  Please share anything that will help prepare for our meeting *
                </label>
                <textarea
                  style={{ caretColor: "black", minHeight: "5rem" }}
                  className="input-text-input text-dark p-2"
                  value={data.description}
                  type="text"
                  required
                  onChange={(e) => updateState("description", e.target.value)}
                />
                <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                  <ReCAPTCHA
                    size={isMobile ? "compact" : "normal"}
                    ref={recaptcha}
                    sitekey={REACT_APP_SITE_KEY}
                  />
                </div>
                <button
                  type="submit"
                  className="scheduleBt"
                  onClick={() => confirmDetails()}
                >
                  <FiCalendar size={18} />
                  {selectedServiceObj
                    ? `Book ${selectedServiceObj.serviceName} - ${priceLabel(selectedServiceObj)}`
                    : "Select a service to book"}
                  <FiArrowRight size={20} />
                </button>
              </form>
            ) : (
              <div className="slotChoseingParent">
                {["group_package", "one_to_one_package"].includes(
                  isPackageSelected?.appointmentName,
                ) ? (
                  <>
                    <div className="scheduleHeader">
                      <h2>
                        <FiCalendar size={18} color="var(--brand, #161616)" /> Group
                        Package Schedule
                      </h2>
                      <p>
                        This package runs on a{" "}
                        <b>{isPackageSelected.packagePeriod}</b> basis.
                      </p>
                    </div>
                    <div
                      className="calTimeSplit"
                      style={{ margin: "20px 20px 0" }}
                    >
                      <div className="calSide">
                        <div className="panelLabel">
                          <FiCalendar size={13} /> Select Date
                        </div>
                        <MonthGridCalendar
                          slots={data.slots}
                          packageDays={packageDays}
                          selectedValue={data.activeIndexData?.value}
                          hoverCol={hoverCol}
                          onSelect={(slotObj) => {
                            const idx = data.slots?.findIndex(
                              (s) => s.value === slotObj.value,
                            );
                            viewAvailableSlot(
                              idx ?? 0,
                              slotObj,
                              slotObj.available,
                            );
                          }}
                        />
                      </div>
                      <TimeSidePanel
                        hasDateSelected={!!data.activeIndexData?.value}
                        slots={timeSlots}
                        selectedSlot={data.selectedSlot}
                        hoverCol={hoverCol}
                        onSelect={(item) => updateState("selectedSlot", item)}
                        isDisabledFn={() => false}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {renderStepper(1)}
                    <div style={{ padding: "1rem 1.25rem .25rem" }}>
                      <div
                        className="scheduleHeader"
                        style={{ marginBottom: ".5rem" }}
                      >
                        <h2>
                          <FiCalendar size={18} color="var(--brand, #161616)" />{" "}
                          Schedule your session
                        </h2>
                        <p>Choose how you'd like to book</p>
                      </div>

                      <div className="bkModeRow">
                        <div
                          className={`bkModeCard${data.bookingMode === "self" ? " bkSelected" : ""}`}
                          onClick={() => updateState("bookingMode", "self")}
                        >
                          <div className="bkModeRadio">
                            {data.bookingMode === "self" && (
                              <div className="bkModeRadioInner" />
                            )}
                          </div>
                          <div className="bkModeText">
                            <h5>I'll pick date &amp; time</h5>
                            <p>Select from available slots</p>
                          </div>
                        </div>

                        <div
                          className={`bkModeCard${data.bookingMode === "expert" ? " bkSelected" : ""}`}
                          onClick={() => updateState("bookingMode", "expert")}
                        >
                          <div className="bkModeRadio">
                            {data.bookingMode === "expert" && (
                              <div className="bkModeRadioInner" />
                            )}
                          </div>
                          <div className="bkModeText">
                            <h5>Let the expert choose</h5>
                            <p>
                              Share your preference and expert will schedule
                            </p>
                          </div>
                        </div>
                      </div>

                      {data.bookingMode === "expert" && (
                        <div className="expertNoteWrap">
                          <label>Share your preference / availability</label>
                          <textarea
                            placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                            value={data.expertNote || ""}
                            onChange={(e) =>
                              updateState("expertNote", e.target.value)
                            }
                          />
                          <p className="expertHint">
                            The expert will review your preference and send you
                            a confirmed slot via email.
                          </p>
                        </div>
                      )}
                    </div>

                    {data.bookingMode === "self" && (
                      <div
                        className="calTimeSplit"
                        style={{ margin: "0 20px" }}
                      >
                        <div className="calSide">
                          <div className="panelLabel">
                            <FiCalendar size={13} /> Select Date
                          </div>
                          <MonthGridCalendar
                            slots={data.slots}
                            packageDays={[]}
                            selectedValue={data.activeIndexData?.value}
                            hoverCol={hoverCol}
                            onSelect={(slotObj) => {
                              const idx = data.slots?.findIndex(
                                (s) => s.value === slotObj.value,
                              );
                              viewAvailableSlot(
                                idx ?? 0,
                                slotObj,
                                slotObj.available,
                              );
                            }}
                          />
                        </div>

                        <div className="timeSide">
                          <div className="panelLabel">
                            <FiClock size={13} /> Available Time Slots
                          </div>

                          {data.activeIndexData?.value && (
                            <div className="tzChip">
                              <FiClock size={11} />
                              {data.eventDetails?.timeZone
                                ? `All times shown in ${data.eventDetails.timeZone}`
                                : "All times shown in Asia/Kolkata (IST)"}
                            </div>
                          )}

                          {!data.activeIndexData?.value ? (
                            <div className="calEmptyState">
                              <FiCalendar size={40} color="#c4c9d8" />
                              <p>
                                <strong>No date selected</strong>
                                Pick a date on the left to see available time
                                slots
                              </p>
                            </div>
                          ) : (
                            <div className="twoColSlots slotPanel">
                              {getAllSlots().length > 0 ? (
                                getAllSlots().map((item, i) => {
                                  const fromStr = item.from ?? "";
                                  const toStr = item.to ?? "";
                                  const fmt =
                                    fromStr.includes("AM") ||
                                    fromStr.includes("PM")
                                      ? "hh:mm A"
                                      : "HH:mm";
                                  const displayFrom = moment(
                                    fromStr,
                                    fmt,
                                  ).isValid()
                                    ? moment(fromStr, fmt).format("h:mm A")
                                    : fromStr;
                                  const displayTo = moment(toStr, fmt).isValid()
                                    ? moment(toStr, fmt).format("h:mm A")
                                    : toStr;
                                  const isSelected =
                                    data.selectedSlot?.from === fromStr &&
                                    data.selectedSlot?.to === toStr;
                                  const isDisabled =
                                    item.slotAvailable === false;
                                  return (
                                    <button
                                      key={i}
                                      className={`timeSlotBtn${isSelected ? " tsActive" : ""}${isDisabled ? " tsDisabled" : ""}`}
                                      style={
                                        isSelected
                                          ? { background: hoverCol }
                                          : {}
                                      }
                                      onClick={() => {
                                        if (!isDisabled) {
                                          updateState("slotActiveIndex", i);
                                          updateState("selectedSlot", item);
                                        }
                                      }}
                                    >
                                      {displayFrom} – {displayTo}
                                    </button>
                                  );
                                })
                              ) : (
                                <p
                                  className="noTimeMsg"
                                  style={{ gridColumn: "1/-1" }}
                                >
                                  No slots available for this date
                                </p>
                              )}
                            </div>
                          )}

                          <div className="sp-confirm-box instantBadge">
                            <FiZap
                              size={18}
                              color="var(--accent, #d97706)"
                              style={{ flexShrink: 0, marginTop: "2px" }}
                            />
                            <div>
                              <h6>Instant confirmation</h6>
                              <p>
                                Your session will be confirmed immediately after
                                booking.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </section>

          {!data.detailsPage && (
            <>
              <button
                className="scheduleBt"
                onClick={() => (isPreview ? () => {} : confirmDetails())}
              >
                <FiCalendar size={18} />
                {selectedServiceObj
                  ? `Book ${selectedServiceObj.serviceName} - ${priceLabel(selectedServiceObj)}`
                  : "Select a service to book"}
                <FiArrowRight size={20} />
              </button>
              <div className="secureFooter">
                <FiShield size={13} color="var(--v3-muted-fg, #999)" />
                Secure Payment &nbsp;•&nbsp; 100% Safe &amp; Trusted
              </div>
            </>
          )}
        </div>
      </div>

      {chosenService === null && (
        <p style={{ color: "var(--v3-muted-fg, #64748b)", fontSize: "13px" }}>
          Choose a service above to see available dates and times.
        </p>
      )}
    </>
  );

  return (
    <div className="v3-page">
      <header className="v3-topbar">
        <div className="v3-topbar-inner">
          <div className="v3-brand">
            <img src={businessLogo} alt="logo" className="v3-brand-mark" />
            <span className="v3-brand-name">
              {data.eventDetails?.serviceName ||
                data.userDetails?.userName ||
                "My Business"}
            </span>
          </div>
          <div className="v3-topbar-actions">
            <button
              type="button"
              className="v3-btn v3-btn-outline v3-btn-sm"
              onClick={onSendMsgClick}
            >
              <FiMail size={14} /> Message
            </button>
            <button
              type="button"
              className="v3-btn v3-btn-sm"
              onClick={() => scrollToRef(scheduleRef)}
            >
              Book a session <FiArrowRight size={14} />
            </button>
          </div>
        </div>
      </header>

      <main className="v3-wrap">
        <section className="v3-hero">
          <div className="v3-hero-grid">
            <div className="v3-hero-avatar-wrap">
              <img
                src={businessLogo}
                alt={data.userDetails?.userName}
                className="v3-hero-avatar"
              />
              <div className="v3-hero-status">
                <span className="v3-status-dot" />
                <span>Available this week</span>
              </div>
            </div>

            <div className="v3-hero-main">
              <div className="v3-hero-badges">
                {data.eventDetails?.serviceName && (
                  <span className="v3-badge">
                    {data.eventDetails.serviceName}
                  </span>
                )}
                <span className="v3-verified-chip">
                  <MdVerified size={14} style={{ color: "var(--brand)" }} />
                  Verified professional
                </span>
              </div>

              <div>
                <h1 className="v3-font-display v3-hero-title">
                  {data.userDetails?.userName}
                </h1>
                {data.userDetails?.profession?.professionName && (
                  <p className="v3-hero-subtitle">
                    {data.userDetails.profession.professionName}
                  </p>
                )}
              </div>

              <div className="v3-meta-row">
                {avgRating && (
                  <span className="v3-meta-rating">
                    <FaStar size={14} color="#fbbf24" />
                    <b style={{ fontWeight: 600 }}>{avgRating}</b>
                    <span>({reviews.length} reviews)</span>
                  </span>
                )}
                {languages && (
                  <span className="v3-meta-chip">
                    <FiGlobe size={14} /> {languages}
                  </span>
                )}
                {data.eventDetails?.timeZone && (
                  <span className="v3-meta-chip">
                    <FiClock size={14} /> {data.eventDetails.timeZone}
                  </span>
                )}
                {data.bookingCount != null && (
                  <span className="v3-meta-chip">
                    <FiCheck size={14} /> {data.bookingCount}+ bookings
                    completed
                  </span>
                )}
              </div>

              <div className="v3-hero-actions">
                <button
                  type="button"
                  className="v3-btn v3-btn-lg"
                  onClick={() => scrollToRef(scheduleRef)}
                >
                  Book now <FiArrowRight size={16} />
                </button>
                <button
                  type="button"
                  className="v3-btn v3-btn-outline v3-btn-lg"
                  onClick={onSendMsgClick}
                >
                  <FiMail size={16} /> Contact
                </button>
                {data?.eventDetails?.slug && (
                  <button
                    type="button"
                    className="v3-btn v3-btn-outline v3-btn-lg"
                    onClick={handleShare}
                  >
                    <FiShare2 size={16} /> Share
                  </button>
                )}
              </div>
            </div>

            <div className="v3-stat-row">
              {data.bookingCount != null && (
                <div className="v3-stat-card">
                  <div className="v3-font-display v3-stat-value">
                    {data.bookingCount}
                  </div>
                  <div className="v3-stat-label">Bookings completed</div>
                </div>
              )}
              {avgRating && (
                <div className="v3-stat-card">
                  <div className="v3-font-display v3-stat-value">
                    {avgRating}
                  </div>
                  <div className="v3-stat-label">Average rating</div>
                </div>
              )}
              <div className="v3-stat-card">
                <div className="v3-font-display v3-stat-value">
                  {reviews.length}
                </div>
                <div className="v3-stat-label">Client reviews</div>
              </div>
            </div>
          </div>
        </section>

        <div className="v3-layout">
          <div className="v3-main-col">
            {data.eventDetails?.description && (
              <section className="v3-section">
                <div className="v3-section-header">
                  <div>
                    <div className="v3-section-eyebrow">About</div>
                    <h2 className="v3-font-display v3-section-title">
                      Working with{" "}
                      {(data.userDetails?.userName || "").split(" ")[0]}
                    </h2>
                  </div>
                </div>
                <div
                  className="v3-about-text"
                  dangerouslySetInnerHTML={{
                    __html: data.eventDetails.description,
                  }}
                />
              </section>
            )}

            {/* ── Specialisations — DB data (comma-separated string) when
                present, static sample tags when null/empty. ── */}
            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Expertise</div>
                  <h2 className="v3-font-display v3-section-title">
                    Specialisations
                  </h2>
                </div>
              </div>
              <div className="v3-chip-row">
                {specialisationTags.map((tag) => (
                  <span key={tag} className="v3-expertise-chip">
                    {tag}
                  </span>
                ))}
              </div>
            </section>

            <section className="v3-section" ref={servicesSectionRef}>
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Services</div>
                  <h2 className="v3-font-display v3-section-title">
                    What you can book
                  </h2>
                </div>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "var(--v3-muted-fg, #64748b)",
                  }}
                >
                  {data.serviceList?.length || 0} available
                </span>
              </div>

              <div className="v3-service-grid">
                {(data.serviceList || []).map((item, ind) => {
                  const active = chosenService === ind;
                  const features = item.features
                    ? item.features.split(",")
                    : [];
                  return (
                    <div
                      key={ind}
                      className={`v3-service-card${active ? " v3-active" : ""}`}
                      onClick={() => selectAndScroll(item, ind)}
                    >
                      <div className="v3-service-head">
                        <div>
                          <h3 className="v3-service-name">
                            {item.serviceName}
                          </h3>
                          <p className="v3-service-desc">{item.description}</p>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div className="v3-font-display v3-service-price">
                            {priceLabel(item)}
                          </div>
                          <div className="v3-service-duration">
                            {item.duration} min
                          </div>
                        </div>
                      </div>

                      {features.length > 0 && (
                        <ul className="v3-service-features">
                          {features.map((f, fi) => (
                            <li key={fi}>
                              <FiCheck
                                size={13}
                                style={{ color: "var(--brand)" }}
                              />{" "}
                              {f}
                            </li>
                          ))}
                        </ul>
                      )}

                      <button
                        type="button"
                        className="v3-btn v3-btn-outline v3-service-btn"
                        style={{ width: "100%" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          selectAndScroll(item, ind);
                        }}
                      >
                        Book this service <FiChevronRight size={16} />
                      </button>
                    </div>
                  );
                })}
                {(!data.serviceList || data.serviceList.length === 0) && (
                  <p style={{ color: "var(--v3-muted-fg, #64748b)" }}>
                    No services available yet.
                  </p>
                )}
              </div>
            </section>

              {/* ── Resources — direct-buy items, no calendar/slot flow. Same visual
    language as Services above (v3-service-grid / v3-service-card) for
    consistency, just with a "Resource" tag and file-count instead of
    duration. Only rendered when resources actually exist. ── */}
{resourceList.length > 0 && (
  <section className="v3-section">
    <div className="v3-section-header">
      <div>
        <div className="v3-section-eyebrow">Ready-made resources</div>
        <h2 className="v3-font-display v3-section-title">
          Get instant access
        </h2>
      </div>
      <span
        style={{
          fontSize: "0.8rem",
          color: "var(--v3-muted-fg, #64748b)",
        }}
      >
        {resourceList.length} available
      </span>
    </div>

    <div className="v3-service-grid">
      {resourceList.map((res) => {
        const isResourceFree = Number(res.amount) === 0;
        const fileCount = res.resourceFileNames?.length || 0;
        return (
          <div
            key={res.id}
            className="v3-service-card"
            onClick={() => handleResourceCardClick(res)}
          >
            <div className="v3-service-head">
              <div>
                <h3 className="v3-service-name">{res.serviceName}</h3>
                <p className="v3-service-desc">{res.description}</p>
              </div>
              <div style={{ textAlign: "right" }}>
                <div className="v3-font-display v3-service-price">
                  {isResourceFree ? "Free" : `₹${res.amount}`}
                </div>
                {fileCount > 0 && (
                  <div className="v3-service-duration">
                    {fileCount} file{fileCount !== 1 ? "s" : ""}
                  </div>
                )}
              </div>
            </div>

            <button
              type="button"
              className="v3-btn v3-btn-outline v3-service-btn"
              style={{ width: "100%" }}
              onClick={(e) => {
                e.stopPropagation();
                handleResourceCardClick(res);
              }}
            >
              {isResourceFree ? (
                <>
                  Get this resource <FiDownload size={16} />
                </>
              ) : (
                <>
                  <FiLock size={14} /> Buy now <FiChevronRight size={16} />
                </>
              )}
            </button>
          </div>
        );
      })}
    </div>
  </section>
)}

            {/* ── Success metrics — DB data (JSON object string) when
                present, static sample values when null/empty. ── */}
            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Success metrics</div>
                  <h2 className="v3-font-display v3-section-title">
                    Numbers that hold up in a board meeting.
                  </h2>
                </div>
              </div>
              <p
                style={{
                  color: "var(--v3-muted-fg, #64748b)",
                  fontSize: "0.85rem",
                  marginTop: "-0.5rem",
                  marginBottom: "1.25rem",
                }}
              >
                Averages across the last 24 months of client engagements.
              </p>
              <div className="v3-metrics-grid">
                {successMetrics.map((m) => (
                  <div key={m.label} className="v3-metric-card">
                    <span className="v3-metric-icon">{m.icon}</span>
                    <div className="v3-font-display v3-metric-value">
                      {m.value}
                    </div>
                    <div className="v3-metric-label">{m.label}</div>
                  </div>
                ))}
              </div>
            </section>

            {/* ── Track record — real numbers only (bookings, rating, review
             count). Unlike success metrics above, this never shows invented
             figures since nothing in your data backs those claims. ── */}
            {(data.bookingCount != null || avgRating || reviews.length > 0) && (
              <section className="v3-section">
                <div className="v3-section-header">
                  <div>
                    <div className="v3-section-eyebrow">Track record</div>
                    <h2 className="v3-font-display v3-section-title">
                      Numbers so far
                    </h2>
                  </div>
                </div>
                <div className="v3-metrics-grid">
                  {[
                    data.bookingCount != null
                      ? {
                          icon: <FiCheck size={18} />,
                          value: `${data.bookingCount}+`,
                          label: "Bookings completed",
                        }
                      : null,
                    avgRating
                      ? {
                          icon: <FaStar size={18} />,
                          value: avgRating,
                          label: "Average rating",
                        }
                      : null,
                    reviews.length > 0
                      ? {
                          icon: <MdOutlineReviews size={18} />,
                          value: reviews.length,
                          label: "Client reviews",
                        }
                      : null,
                    data.serviceList?.length
                      ? {
                          icon: <FiCalendar size={18} />,
                          value: data.serviceList.length,
                          label: "Services offered",
                        }
                      : null,
                  ]
                    .filter(Boolean)
                    .map((m) => (
                      <div key={m.label} className="v3-metric-card">
                        <span className="v3-metric-icon">{m.icon}</span>
                        <div className="v3-font-display v3-metric-value">
                          {m.value}
                        </div>
                        <div className="v3-metric-label">{m.label}</div>
                      </div>
                    ))}
                </div>
              </section>
            )}

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">How it works</div>
                  <h2 className="v3-font-display v3-section-title">
                    Your booking journey
                  </h2>
                </div>
              </div>
              <div className="v3-journey-wrap">
                <div className="v3-journey-rail" />
                <ol className="v3-journey-list">
                  {[
                    {
                      icon: <FiCalendar size={16} />,
                      title: "Pick a service",
                      desc: "Choose what fits what you need.",
                    },
                    {
                      icon: <FiClock size={16} />,
                      title: "Select slot",
                      desc: "Live availability, updated in real time.",
                    },
                    {
                      icon: <FiCheck size={16} />,
                      title: "Confirm details",
                      desc: "Share a few lines about what to cover.",
                    },
                    {
                      icon: <FiZap size={16} />,
                      title: "Confirmation",
                      desc: "Instant confirmation, no waiting.",
                    },
                    {
                      icon: <FiVideo size={16} />,
                      title: "Meeting",
                      desc: "Join the live session at your scheduled time.",
                    },
                    {
                      icon: <FiRefreshCw size={16} />,
                      title: "Follow-up",
                      desc: "Notes and next steps after your session.",
                    },
                  ].map((s, i) => (
                    <li key={s.title}>
                      <div
                        className="v3-journey-icon"
                        style={{ background: "var(--brand)" }}
                      >
                        {s.icon}
                      </div>
                      <div className="v3-journey-step-label">Step {i + 1}</div>
                      <div className="v3-journey-title">{s.title}</div>
                      <div className="v3-journey-desc">{s.desc}</div>
                    </li>
                  ))}
                </ol>
              </div>
            </section>

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Track record</div>
                  <h2 className="v3-font-display v3-section-title">
                    Recent work
                  </h2>
                </div>
              </div>
              <div className="v3-timeline">
                <div className="v3-timeline-rail" />
                <div className="v3-timeline-items">
                  {(data.recommendList?.length > 0
                    ? data.recommendList.slice(0, 4).map((item) => ({
                        title: item.name || "Client recommendation",
                        meta: "Recommended",
                        detail: item.suggestion,
                      }))
                    : [
                        {
                          title: "Personalised session plans",
                          meta: "Ongoing",
                          detail:
                            "Every session is tailored to what the client actually needs, not a fixed script.",
                        },
                        {
                          title: "Flexible scheduling",
                          meta: "Ongoing",
                          detail:
                            "Slots open up across the week, with instant confirmation once booked.",
                        },
                        {
                          title: "Client-first follow-up",
                          meta: "Ongoing",
                          detail:
                            "Notes and next steps shared after every session so nothing gets lost.",
                        },
                      ]
                  ).map((p, i) => (
                    <div key={i} className="v3-timeline-item">
                      <div
                        className="v3-timeline-dot"
                        style={{ background: "var(--brand)" }}
                      />
                      <div className="v3-timeline-card">
                        <div className="v3-timeline-head">
                          <h3 className="v3-timeline-title">{p.title}</h3>
                          <span className="v3-timeline-meta">{p.meta}</span>
                        </div>
                        <p className="v3-timeline-detail">{p.detail}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Proof of work</div>
                  <h2 className="v3-font-display v3-section-title">
                    See the work, hear from clients
                  </h2>
                </div>
              </div>

              <div
                className="v3-tab-scroll"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  marginBottom: "1.25rem",
                }}
              >
                {resTabList.map((tb, ind) => (
                  <button
                    key={ind}
                    type="button"
                    className={`v3-btn ${focusTab === ind ? "" : "v3-btn-outline"} v3-btn-sm`}
                    onClick={() => {
                      setFocusTab(ind);
                      setVideoPlaying(false);
                    }}
                  >
                    {tb.icon} {tb.title}
                  </button>
                ))}
              </div>

              {(focusTab === 0 || focusTab === 1) &&
                (activeProofList.length > 0 ? (
                  <div className="v3-service-grid">
                    {activeProofList.map((img, i) => (
                      <div
                        key={i}
                        className="v3-service-card"
                        style={{
                          padding: 0,
                          overflow: "hidden",
                          aspectRatio: "4/3",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setChosenRes({ type: "image", url: img });
                          setShowResModal(true);
                        }}
                      >
                        <img
                          src={img}
                          alt={`${resTabList[focusTab].title} ${i + 1}`}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p
                    style={{
                      color: "var(--v3-muted-fg, #64748b)",
                      fontSize: "0.85rem",
                    }}
                  >
                    No {resTabList[focusTab].title.toLowerCase()} to show yet.
                  </p>
                ))}

              {focusTab === 2 &&
                (state.serviceProviderVideo.length > 0 ? (
                  <div>
                    {!videoPlaying ? (
                      <button
                        type="button"
                        className="v3-service-card"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.75rem",
                          width: "100%",
                          textAlign: "left",
                          cursor: "pointer",
                        }}
                        onClick={() => setVideoPlaying(true)}
                      >
                        <span className="v3-contact-icon">
                          <FiVideo size={18} />
                        </span>
                        <span>
                          <div className="v3-service-name">
                            Watch a short introduction
                          </div>
                          <div className="v3-service-desc">
                            From{" "}
                            {data.userDetails?.userName ||
                              data.eventDetails?.serviceName}
                          </div>
                        </span>
                      </button>
                    ) : (
                      <video
                        controls
                        autoPlay
                        style={{
                          width: "100%",
                          borderRadius: "18px",
                          display: "block",
                        }}
                      >
                        <source
                          src={`${API_URL}auth/video/${state.serviceProviderVideo[0]}`}
                        />
                      </video>
                    )}
                  </div>
                ) : (
                  <p
                    style={{
                      color: "var(--v3-muted-fg, #64748b)",
                      fontSize: "0.85rem",
                    }}
                  >
                    No video to show yet.
                  </p>
                ))}

              {focusTab === 3 &&
                (reviews.length > 0 ? (
                  <div className="v3-reviews-grid">
                    {reviews.slice(0, 4).map((item, ind) => (
                      <div key={ind} className="v3-review-card">
                        <div className="v3-review-head">
                          <div className="v3-avatar">
                            {(item.name || "?")[0]?.toUpperCase()}
                          </div>
                          <div>
                            <div className="v3-review-name">{item.name}</div>
                            <div className="v3-review-date">
                              {moment(new Date(item.updateDate)).format(
                                "DD MMM YYYY",
                              )}
                            </div>
                          </div>
                          <div className="v3-review-stars">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <FaStar
                                key={i}
                                size={13}
                                color={
                                  i < Math.round(item.satisfaction || 0)
                                    ? "#fbbf24"
                                    : "#e2e8f0"
                                }
                              />
                            ))}
                          </div>
                        </div>
                        <p className="v3-review-text">
                          &ldquo;{item.suggestion}&rdquo;
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p
                    style={{
                      color: "var(--v3-muted-fg, #64748b)",
                      fontSize: "0.85rem",
                    }}
                  >
                    No reviews yet.
                  </p>
                ))}

              {reviews.length > 0 && (
                <button
                  type="button"
                  className="v3-btn v3-btn-outline"
                  style={{ marginTop: "1.25rem" }}
                  onClick={handleOpenReviews}
                >
                  See all {reviews.length} reviews <FiChevronRight size={16} />
                </button>
              )}
            </section>

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Credentials</div>
                  <h2 className="v3-font-display v3-section-title">
                    Trust, verified
                  </h2>
                </div>
              </div>
              <div className="v3-credential-grid">
                {[
                  {
                    icon: <MdVerified size={16} />,
                    label: "Verified professional",
                  },
                  { icon: <FiShield size={16} />, label: "Secure payments" },
                  { icon: <FiZap size={16} />, label: "Instant confirmation" },
                  avgRating
                    ? {
                        icon: <FaStar size={16} />,
                        label: `${avgRating} average rating`,
                      }
                    : null,
                  data.bookingCount != null
                    ? {
                        icon: <FiCheck size={16} />,
                        label: `${data.bookingCount}+ bookings completed`,
                      }
                    : null,
                  reviews.length > 0
                    ? {
                        icon: <MdOutlineReviews size={16} />,
                        label: `${reviews.length}+ client reviews`,
                      }
                    : null,
                ]
                  .filter(Boolean)
                  .map((b) => (
                    <div key={b.label} className="v3-credential-card">
                      <span className="v3-contact-icon">{b.icon}</span>
                      <div
                        className="v3-service-name"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {b.label}
                      </div>
                    </div>
                  ))}
              </div>
            </section>

            {reviews.length > 0 && (
              <section className="v3-section">
                <div className="v3-section-header">
                  <div>
                    <div className="v3-section-eyebrow">Reviews</div>
                    <h2 className="v3-font-display v3-section-title">
                      {avgRating ? `${avgRating} · ` : ""}
                      {reviews.length} verified review
                      {reviews.length !== 1 ? "s" : ""}
                    </h2>
                  </div>
                  <button
                    type="button"
                    className="v3-btn v3-btn-outline v3-btn-sm"
                    onClick={handleOpenReviews}
                  >
                    See all <FiChevronRight size={14} />
                  </button>
                </div>
                <div className="v3-reviews-grid">
                  {reviews.slice(0, 4).map((item, ind) => (
                    <div key={ind} className="v3-review-card">
                      <div className="v3-review-head">
                        <div className="v3-avatar">
                          {(item.name || "?")[0]?.toUpperCase()}
                        </div>
                        <div>
                          <div className="v3-review-name">{item.name}</div>
                          <div className="v3-review-date">
                            {moment(new Date(item.updateDate)).format(
                              "DD MMM YYYY",
                            )}
                          </div>
                        </div>
                        <div className="v3-review-stars">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <FaStar
                              key={i}
                              size={13}
                              color={
                                i < Math.round(item.satisfaction || 0)
                                  ? "#fbbf24"
                                  : "#e2e8f0"
                              }
                            />
                          ))}
                        </div>
                      </div>
                      <p className="v3-review-text">
                        &ldquo;{item.suggestion}&rdquo;
                      </p>
                    </div>
                  ))}
                </div>
              </section>
            )}

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">FAQ</div>
                  <h2 className="v3-font-display v3-section-title">
                    Common questions
                  </h2>
                </div>
              </div>
              <div className="v3-faq-card">
                {(data.eventDetails?.faq?.length > 0
                  ? data.eventDetails.faq
                  : [
                      {
                        q: "How soon can I book a session?",
                        a: "Pick any open slot on the calendar above — availability updates in real time.",
                      },
                      {
                        q: "What happens after I book?",
                        a: "You'll get instant confirmation, plus a reminder ahead of your session.",
                      },
                      {
                        q: "Can I cancel or reschedule?",
                        a: "Yes — free cancellation up to 24 hours before your scheduled session.",
                      },
                      {
                        q: "Is payment secure?",
                        a: "Yes, payments are processed securely and your session is only confirmed once payment succeeds.",
                      },
                    ]
                ).map((f, i) => (
                  <details key={i} className="v3-faq-item">
                    <summary>
                      {f.q}{" "}
                      <FiChevronRight size={16} className="v3-faq-chevron" />
                    </summary>
                    <p>{f.a}</p>
                  </details>
                ))}
              </div>
            </section>

            <section className="v3-section">
              <div className="v3-section-header">
                <div>
                  <div className="v3-section-eyebrow">Contact</div>
                  <h2 className="v3-font-display v3-section-title">
                    Get in touch
                  </h2>
                </div>
              </div>
              <div className="v3-contact-card">
                <div className="v3-contact-grid">
                  <div className="v3-contact-item">
                    <span className="v3-contact-icon">
                      <FiMail size={16} />
                    </span>
                    <div>
                      <div className="v3-contact-label">Message</div>
                      <button
                        type="button"
                        className="v3-contact-value"
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={onSendMsgClick}
                      >
                        Send a message
                      </button>
                    </div>
                  </div>
                  {data.userDetails?.personalWebsite && (
                    <div className="v3-contact-item">
                      <span className="v3-contact-icon">
                        <FiGlobe size={16} />
                      </span>
                      <div>
                        <div className="v3-contact-label">Website</div>
                        <button
                          type="button"
                          className="v3-contact-value"
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() =>
                            window.open(
                              data.userDetails.personalWebsite,
                              "_blank",
                            )
                          }
                        >
                          Visit website
                        </button>
                      </div>
                    </div>
                  )}
                  {data.eventDetails?.timeZone && (
                    <div className="v3-contact-item">
                      <span className="v3-contact-icon">
                        <FiClock size={16} />
                      </span>
                      <div>
                        <div className="v3-contact-label">Time zone</div>
                        <div className="v3-contact-value">
                          {data.eventDetails.timeZone}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {data.socialMedia?.length > 0 && (
                  <div className="v3-social-row">
                    {data.socialMedia.map((item, i) => (
                      <a
                        key={i}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={item.icon}
                          alt="social"
                          style={{
                            width: 14,
                            height: 14,
                            objectFit: "contain",
                          }}
                        />
                      </a>
                    ))}
                  </div>
                )}

                {data?.eventDetails?.slug && (
                  <div
                    style={{
                      marginTop: "1.25rem",
                      paddingTop: "1.25rem",
                      borderTop: "1px solid var(--v3-border, #e2e8f0)",
                    }}
                  >
                    <div
                      className="v3-contact-label"
                      style={{ marginBottom: "0.6rem" }}
                    >
                      Refer a friend
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <img
                        src={serviceShareQr}
                        alt="QR code"
                        loading="lazy"
                        style={{
                          width: 68,
                          height: 68,
                          borderRadius: 8,
                          border: "1px solid var(--v3-border, #e2e8f0)",
                          background: "#fff",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <button
                          type="button"
                          className="v3-btn v3-btn-outline v3-btn-sm"
                          onClick={handleCopyLink}
                        >
                          {copiedLink ? "✓ Copied" : "Copy link"}
                        </button>
                        <button
                          type="button"
                          className="v3-btn v3-btn-outline v3-btn-sm"
                          onClick={handleWhatsAppShare}
                          style={{ borderColor: "#25D366", color: "#25D366" }}
                        >
                          <FaWhatsapp size={14} /> WhatsApp
                        </button>
                        <button
                          type="button"
                          className="v3-btn v3-btn-outline v3-btn-sm"
                          onClick={handleShare}
                        >
                          <FiShare2 size={14} /> Share
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
          <aside className="v3-side-col" id="book" ref={scheduleRef}>
            <div className="v3-booking-card">
              <div
                className="v3-booking-card-head"
                style={{ background: "var(--brand-soft)" }}
              >
                <div className="v3-booking-card-head-row">
                  <div>
                    <div
                      className="v3-booking-eyebrow"
                      style={{ color: "var(--brand)" }}
                    >
                      {selectedServiceObj
                        ? selectedServiceObj.serviceName
                        : "Book a session"}
                    </div>
                    <div className="v3-font-display v3-booking-price">
                      {selectedServiceObj ? (
                        priceLabel(selectedServiceObj)
                      ) : minServiceAmount !== null ? (
                        <>From {priceLabel({ amount: minServiceAmount })}</>
                      ) : (
                        "Contact for pricing"
                      )}
                    </div>
                  </div>
                  <FiCalendar size={20} style={{ color: "var(--brand)" }} />
                </div>
              </div>

              <div className="v3-booking-card-body">{bookingInner}</div>
            </div>
          </aside>
        </div>

        <section className="v3-footer-cta">
          <div
            className="v3-footer-cta-inner"
            style={{
              background:
                "radial-gradient(900px 300px at 10% 0%, var(--brand-soft), transparent 60%), var(--v3-surface)",
            }}
          >
            <div className="v3-footer-cta-grid">
              <div>
                <div
                  className="v3-section-eyebrow"
                  style={{ color: "var(--brand)" }}
                >
                  Ready when you are
                </div>
                <h2 className="v3-font-display v3-footer-cta-title">
                  Ready to achieve your goals with{" "}
                  {(data.userDetails?.userName || "").split(" ")[0]}?
                </h2>
                <p className="v3-footer-cta-text">
                  Book your first session today. Free cancellation up to 24
                  hours before.
                </p>
              </div>
              <div className="v3-footer-cta-actions">
                <button
                  type="button"
                  className="v3-btn v3-btn-lg"
                  onClick={() => scrollToRef(scheduleRef)}
                >
                  Book now <FiArrowRight size={16} />
                </button>
                <button
                  type="button"
                  className="v3-btn v3-btn-outline v3-btn-lg"
                  onClick={onSendMsgClick}
                >
                  <FiMail size={16} /> Message{" "}
                  {(data.userDetails?.userName || "").split(" ")[0]}
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <div className="v3-mobile-bar">
        <div className="v3-mobile-bar-inner">
          <div style={{ minWidth: 0 }}>
            <div className="v3-mobile-service-name">
              {selectedServiceObj?.serviceName ||
                data.eventDetails?.serviceName ||
                "Book a session"}
            </div>
            <div className="v3-font-display v3-mobile-price">
              {selectedServiceObj ? (
                priceLabel(selectedServiceObj)
              ) : minServiceAmount !== null ? (
                <>From {priceLabel({ amount: minServiceAmount })}</>
              ) : (
                "—"
              )}
            </div>
          </div>
          <button
            type="button"
            className="v3-btn v3-btn-sm"
            onClick={() => scrollToRef(scheduleRef)}
          >
            Book now <FiArrowRight size={14} />
          </button>
        </div>
      </div>

      <div className="v3-wrap">
        <footer className="v3-site-footer">
          © {new Date().getFullYear()}{" "}
          {data.eventDetails?.serviceName ||
            data.userDetails?.userName ||
            "My Business"}
          {" · "}Powered by{" "}
          <a
            href="https://yuukke.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Yuukke
          </a>
        </footer>
      </div>

      {showResModal && chosenRes.type === "image" && chosenRes.url && (
        <div
          onClick={() => setShowResModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.85)",
            zIndex: 1100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "30px",
          }}
        >
          <img
            src={chosenRes.url}
            alt="preview"
            loading="lazy"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: "10px",
              display: "block",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ServiceCardThemeV3;